import { FC, PropsWithChildren } from 'react';
import { CustomerAccountSideMenuItemProps } from '../../types';
import { CatSideMenuItem } from '@blocks-react/components/SideMenuItem';

export const CustomerAccountSideMenuItem: FC<
  PropsWithChildren<CustomerAccountSideMenuItemProps>
> = ({ children, ...menuItemProp }) => {
  return <CatSideMenuItem {...menuItemProp}>{children}</CatSideMenuItem>;
};
